import { useContext } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import ContextStates from "../context/ContextStates";

const LogoutButton = () => {
	const { setCliente } = useContext(ContextStates);
	const { logout } = useAuth0();
	
	const logOut = () => {
		localStorage.removeItem('localClient')
		setCliente();
		logout({ logoutParams: { returnTo: window.location.origin } })
	}

	return (
		<button 
			className="group flex w-full items-center rounded-md px-2 py-2 text-sm hover:bg-blue-500 hover:text-white"
			onClick={() => logOut()}
		>
			Cerrar Sesión
		</button>
	);
};

export default LogoutButton;